<template>
  <field-form id="pfid1657266347" @save="save" :saving="saving"  v-if="item">
  <h2 class="text-h4">{{ item.name }}</h2>
  <v-row>
  <v-col cols="12" lg="6">
  <v-card class="fill-height">
    <v-card-title>{{ $t('forms.edit.overview.title')}}</v-card-title>
      <v-list>
        <v-list-item
        id="pfid1657267601"
        two-line 
        >
            <v-list-item-icon>
                <v-icon>$name</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <template v-if="!edit.name">
                <v-list-item-subtitle>{{$t('common.name')}}</v-list-item-subtitle>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
                </template>
                <v-text-field v-else dense :label="$t('common.name')" v-model="fields.name" :rules="[v => !!v || $t('form.rules.required')]"/>
            </v-list-item-content>
            <v-list-item-action>
                <action-button v-if="!edit.name" @click="editable('name')"/>
                <v-row v-else class="my-0 mr-0">
                    <action-button icon="$close" @click="edit.name=false" :tooltip="$t('dialog.back')"/>
                    <action-button icon="$save" :tooltip="$t('form.save')" @click="savin.name = true" type="submit" :loading="savin.name"/>
                </v-row>
            </v-list-item-action>
        </v-list-item>
        <v-list-item :to="{ name: 'segment', params: { segment: item.tag.id } }">
        <v-list-item-icon>
                <v-icon>$tag</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle>{{$t('campaigns.segment.tag.title')}}</v-list-item-subtitle>
          <v-list-item-title>{{ item.tag.name }}</v-list-item-title>
        </v-list-item-content>
        </v-list-item>
     </v-list>
    <v-card-title>{{ $t('forms.edit.code.title')}}</v-card-title>
    <template v-if="isComplete">
    <v-card-text>
      <p v-html="$t('forms.edit.code.instructions')"></p>
      <code-block language="html" :code="code" as-text>
    </code-block>
    </v-card-text>
    </template>
    <v-card-text v-else>
      <v-alert colored-border type="warning" border="left">
        <p>{{ $t('forms.edit.code.incomplete')}}</p>
      </v-alert>
    </v-card-text>
  </v-card>
  </v-col>
  <v-col cols="12" lg="6">
  <v-card class="fill-height">
    <v-card-title>{{ $t('forms.edit.setup.title')}}</v-card-title>
    <v-tabs v-model="tab" grow>
      <v-tab>{{ $t('forms.edit.setup.tabs.optinPage')}}</v-tab>
      <v-tab>{{ $t('forms.edit.setup.tabs.optinEmail')}}</v-tab>
      <v-tab>{{ $t('forms.edit.setup.tabs.thxPage')}}</v-tab>
    </v-tabs>
    
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card-text>
          <p v-html="$t('forms.edit.setup.optinPage.instructions')"></p>
          <v-text-field id="pfid1657276059" 
          :label="$t('forms.edit.setup.optinPage.redirect')"
          prepend-icon="$url" 
          v-model="fields.optinRedirect"
          :placeholder="$t('forms.edit.setup.optinPage.placeholders.redirect')"
          :hint="$t(`forms.edit.setup.optinPage.hints.redirect`)"
          persistent-hint
          :rules=[rules.url]
          class="pr-3" 
          clearable />
        </v-card-text>
        <v-card-subtitle>{{ $t('forms.edit.setup.optinPage.page') }}</v-card-subtitle>
        <v-card-text>
          
            
          <v-text-field  
            id="pfid1628066750" 
            v-model="optinPage.heading" 
            :label="$t('forms.edit.setup.optinPage.heading')"
            prepend-icon="$heading"
            :placeholder="$t('forms.edit.setup.optinPage.placeholders.heading')"
            class="pr-3"
            :disabled="!!fields.optinRedirect"
            clearable
            />
          <v-textarea 
            id="pfid1628067255"  
            v-model="optinPage.text" 
            prepend-icon="$text" 
            :label="$t('forms.edit.setup.optinPage.text')"
            :placeholder="$t('forms.edit.setup.optinPage.placeholders.text')"
            class="pr-3"
            :disabled="!!fields.optinRedirect"
            clearable
            />
            </v-card-text>
            <v-expansion-panels flat>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <v-card-subtitle class="pa-0">{{ $t('form.advanced')}}</v-card-subtitle>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-text-field 
                      id="pfid1628066729"
                      v-model="optinPage.title" 
                      :label="$t('forms.edit.setup.optinPage.title')"
                      prepend-icon="$tab"
                      :placeholder="$t('forms.edit.setup.optinPage.placeholders.title')"
                      class="pr-3"
                      clearable
                      :disabled="!!fields.optinRedirect"
                      />
                      
                  <v-text-field 
                        id="pfid1657276457" 
                        v-model="optinPage.logo" 
                        :label="$t('forms.edit.setup.optinPage.logo')"
                        prepend-icon="$image"
                        placeholder="https://example.com/logo.png"
                        :hint="$t(`forms.edit.setup.optinPage.hints.logo`)"
                        persistent-hint
                        class="pr-3"
                        clearable
                        :disabled="!!fields.optinRedirect"
                        :rules="[rules.url]"
                      />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

        
        <v-card-actions>
        <v-btn :disabled="!!fields.optinRedirect" text color="primary" @click="openPreview('optinPage')"><v-icon left>$view</v-icon>{{$t('customizations.unsubscribe.preview')}}</v-btn>
      </v-card-actions>
      </v-tab-item>
      <v-tab-item>
        <v-card-text v-if="domain">
        <p v-html="$t('forms.edit.setup.optinEmail.instructions')"></p>
        <v-text-field id="pfid1657272706"  :label="$t('campaigns.setup.sender.email')" placeholder="news" prepend-icon="$mailing" v-model="fields.optinFrom" :suffix="`@${domain.dnsName || domain.name}`"  :rules="[rules.inbox]" class="pr-3"></v-text-field>
        <v-text-field id="pfid1657272710" :label="$t('campaigns.setup.sender.name')" :placeholder="item.name" prepend-icon="$rename" v-model="fields.optinFriendlyFrom" class="pr-3"></v-text-field>
        <v-text-field id="pfid1657272714" :label="$t('campaigns.setup.sender.replyTo')" :placeholder="$t('mailing.message.placeholder.replyTo')" prepend-icon="$mailing" v-model="fields.optinReplyTo" :suffix="`@${domain.dnsName || domain.name}`" :rules="[rules.inbox]" class="pr-3"></v-text-field>
        </v-card-text>
        <v-card-subtitle>{{ $t('forms.edit.setup.optinEmail.content.title') }}</v-card-subtitle>
        <v-card-text>
          <v-text-field 
            id="pfid1657279364" 
            v-model="optinEmail.title" 
            :label="$t('forms.edit.setup.optinEmail.title')"
            prepend-icon="$tab"
            :placeholder="$t('forms.edit.setup.optinEmail.placeholders.title')"
            class="pr-3"
            clearable
            />
            
            
            
          <v-text-field  
            id="pfid1657279375" 
            v-model="optinEmail.heading" 
            :label="$t('forms.edit.setup.optinEmail.heading')"
            prepend-icon="$heading"
            :placeholder="$t('forms.edit.setup.optinEmail.placeholders.heading')"
            class="pr-3"
            clearable
            />
          <v-textarea 
            id="pfid1657279381"   
            v-model="optinEmail.text" 
            prepend-icon="$text" 
            :label="$t('forms.edit.setup.optinEmail.text')"
            :placeholder="$t('forms.edit.setup.optinEmail.placeholders.text')"
            class="pr-3"
            clearable
            />
            <v-text-field 
            id="pfid1657279465"    
            v-model="optinEmail.buttonText" 
            prepend-icon="$button" 
            :label="$t('forms.edit.setup.optinEmail.buttonText')"
            :placeholder="$t('forms.edit.setup.optinEmail.placeholders.buttonText')"
            class="pr-3"
            clearable
            />
            <!--
            <color-styling v-bind.sync="colorPicker" css="color" :title="$t('webboxes.styling.buttonColor')" @pick="openPicker" @clear="clearColor"/>
            -->
            
            
            
        </v-card-text>

        <v-expansion-panels flat>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <v-card-subtitle class="pa-0">{{ $t('form.advanced')}}</v-card-subtitle>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-text-field 
                    id="pfid1657279370"  
                    v-model="optinEmail.logo" 
                    :label="$t('forms.edit.setup.optinPage.logo')"
                    prepend-icon="$image"
                    placeholder="https://example.com/logo.png"
                    :hint="$t(`forms.edit.setup.optinEmail.hints.logo`)"
                    persistent-hint
                    class="pr-3"
                    clearable
                    :rules="[rules.url]"
                  />
                      
                  <v-row no-gutters align="center" class="pt-3">
                  <label class="v-label d-block pr-3"><v-icon left>$color</v-icon>{{$t('webboxes.styling.buttonColor')}}</label> 
                  <v-icon x-large :color="optinEmail.buttonColor">$colorPreview</v-icon><action-button 
                      :tooltip="$t('webboxes.styling.color.edit')" 
                      icon="$edit"
                      @click="openPicker"  
                      />
                  <action-button class="pfcl1618818360" 
                      :tooltip="$t('webboxes.styling.color.remove')" 
                      icon="$clear"
                      @click="clearColor()" 
                      />
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

        <v-card-actions>
          <v-menu offset-y top :close-on-content-click="false" v-model="previewMenu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn id="pfid1657279988" :loading="sending" color="primary" text v-on="on" v-bind="attrs"><v-icon left>$send</v-icon>{{$t('campaigns.summary.preview.send')}}</v-btn>
            </template>
            <v-card style="width:300px">
              <v-card-title>{{$t('campaigns.summary.preview.recipient')}}</v-card-title>
              <v-card-text>
                <v-text-field
                  id="pfid1619086822" 
                  v-model="recipient"
                  append-outer-icon="$send"
                  @click:append-outer="sendPreview"
                />
              </v-card-text>
            </v-card>
        </v-menu>
        </v-card-actions>
      </v-tab-item>
      <v-tab-item>
        <v-card-text>
        <p v-html="$t('forms.edit.setup.thxPage.instructions')"></p>
       <v-text-field 
          id="pfid1657276059" 
          :label="$t('forms.edit.setup.optinPage.redirect')"
          prepend-icon="$url" 
          v-model="fields.thxRedirect"
          :placeholder="$t('forms.edit.setup.optinPage.placeholders.redirect')"
          :rules=[rules.url]
          class="pr-3" 
          clearable />
        </v-card-text>
        <v-card-subtitle>{{ $t('forms.edit.setup.optinPage.page') }}</v-card-subtitle>
        <v-card-text>
          
          <v-text-field  
            id="pfid1628066750" 
            v-model="thxPage.heading" 
            :label="$t('forms.edit.setup.optinPage.heading')"
            prepend-icon="$heading"
            :placeholder="$t('forms.edit.setup.thxPage.placeholders.heading')"
            class="pr-3"
            :disabled="!!fields.thxRedirect"
            clearable
            />
          <v-textarea 
            id="pfid1628067255"  
            v-model="thxPage.text" 
            prepend-icon="$text" 
            :label="$t('forms.edit.setup.optinPage.text')"
            :placeholder="$t('forms.edit.setup.thxPage.placeholders.text')"
            class="pr-3"
            :disabled="!!fields.thxRedirect"
            clearable
            />
        </v-card-text>
        <v-expansion-panels flat>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <v-card-subtitle class="pa-0">{{ $t('form.advanced')}}</v-card-subtitle>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-text-field 
                    id="pfid1628066729"
                    v-model="thxPage.title" 
                    :label="$t('forms.edit.setup.optinPage.title')"
                    prepend-icon="$tab"
                    :placeholder="$t('forms.edit.setup.thxPage.placeholders.title')"
                    class="pr-3"
                    clearable
                    :disabled="!!fields.thxRedirect"
                  />
                  <v-text-field 
                    id="pfid1657276457" 
                    v-model="thxPage.logo" 
                    :label="$t('forms.edit.setup.optinPage.logo')"
                    prepend-icon="$image"
                    placeholder="https://example.com/logo.png"
                    :hint="$t(`forms.edit.setup.optinPage.hints.logo`)"
                    persistent-hint
                    class="pr-3"
                    clearable
                    :disabled="!!fields.thxRedirect"
                    :rules="[rules.url]"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
        <v-card-actions>
        <v-btn :disabled="!!fields.thxRedirect" text color="primary" @click="openPreview('thxPage')"><v-icon left>$view</v-icon>{{$t('customizations.unsubscribe.preview')}}</v-btn>
      </v-card-actions>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
  </v-col>
  </v-row>
  <confirm-dialog title="dialog.unsaved.title" button-caption="dialog.leave" v-model="leaveDialog" @confirm="confirmLeave(true)" @cancel="confirmLeave(false)">
          {{$t('dialog.unsaved.text')}}
  </confirm-dialog>
  <v-navigation-drawer app right temporary v-model="colorPicker.dialog" width="500">
    <v-card elevation="0">
      <v-card-title>{{$t('webboxes.colors.title')}}</v-card-title>
      <v-card-text>
    <v-color-picker
      width="500"
      dot-size="25"
      mode="hexa"
      show-swatches
      swatches-max-height="500"
      v-model="colorPicker.selected"
    ></v-color-picker>
      </v-card-text>
    </v-card>
    <template v-slot:append>
        <div class="pa-5">
          <v-btn block color="primary" @click="updateColor">{{$t('webboxes.colors.choose')}}</v-btn>
        </div>
      </template> 
  </v-navigation-drawer>
  </field-form>
  <v-skeleton-loader v-else type="card" />
</template>

<script>

import ParseRoute from '@/mixins/parse-route'
import ConfirmLeave from '@/mixins/confirm-leave'
import EntityForm from '@/mixins/entity-form'
import CodeBlock from '@/components/CodeBlock'
import { mapState, mapGetters } from 'vuex'
import He from 'he';

export default {
  name: 'leadForm',
  components: {CodeBlock},
  mixins: [ConfirmLeave, ParseRoute, EntityForm],
  data() {
    return {
      endpoint: 'forms',
      fields: {
        name: null,
        optinFriendlyFrom: null,
        optinFrom: null,
        optinReplyTo: null,
        optinEmail: null,
        optinRedirect: null,
        optinPage: null,
        thxRedirect: null,
        thxPage: null,
      },
      optinEmail: {
        buttonText: null,
        heading: null,
        text: null,
        title: null,
        logo: null,
        buttonColor: null
      },
      thxPage: {
        heading: null,
        text: null,
        title: null,
        logo: null,
      },
      optinPage: {
        heading: null,
        text: null,
        title: null,
        logo: null,
      },
      // copiet from setup overview
      edit: {
        name: false
      },
      savin: {
        name: false
      },
      tab: null,
      previewMenu: false,
      recipient: this.$store.getters['auth/email'],
      sending: false,
      colorPicker: { 
        dialog: false,
        //color: null,
        selected: null 
      },
    }
  },
  computed: {
    isComplete() {
      //console.debug('isComplete',!!this.item.optinFrom,!!this.item.optinRedirect,this.hasFields(this.item.optinPage, ['heading','text','title']), !!this.item.thxRedirect, this.hasFields(this.item.thxPage, ['heading','text','title']) )
      
      return !!this.item.optinFrom 
      /*
      && this.hasFields(this.item.optinEmail, ['buttonText','heading','text','title'])
      && (!!this.item.optinRedirect || this.hasFields(this.item.optinPage, ['heading','text','title']))
      && (!!this.item.thxRedirect || this.hasFields(this.item.thxPage, ['heading','text','title']))
      */
    },
    code() {
      return `<form 
  action="${this.trackerUrl}/visitors/form/${this.item.id}"
  method="POST">
  <label for="email">${ this.$t('forms.code.label')}</label>
  <input type="email" id="email" name="email" autocomplete="email">
  <button type="submit" class="btn button">${ this.$t('forms.code.button') }</button>
</form>`
    },
    
    ...mapState('domains', { domain: 'item'}),
    ...mapGetters('ui', ['trackerUrl', 'baseUrl'])

  },
  methods: {
    //copied from setup overview
    editable(key) {
      Object.keys(this.edit).forEach(k => this.edit[k] = false);
      this.edit[key] = true;
      this.savin[key] = false;
    },
    hasFields(o, f) {
      return f.every(f => !!o?.[f] && o?.[f].length > 0)
    },
    prepareFields() {
        //this.optinEmail.buttonColor = this.colorPicker.color;
        this.fields.optinEmail = this.optinEmail;
        this.fields.thxPage = this.thxPage;
        this.fields.optinPage = this.optinPage;
        return true;
    },
    afterFieldsLoad() {
      ['thxPage','optinPage','optinEmail'].forEach(f => {
        if(this.item[f]) {
        Object.keys(this.item[f]).forEach(k => {
          this[f][k] = this.item[f][k];
        })
      }
      })
      if(this.item.optinEmail) {
        this.colorPicker.color = this.item.optinEmail.buttonColor;
      }
    },
    // copied from tracker
    getPagePreview(page,pageSetup) {
      let search = '?';
      if(pageSetup) {
        search += Object.keys(pageSetup).filter(k => !!pageSetup[k]).map(k => `${k}=${encodeURIComponent(He.encode(pageSetup[k]))}`).join('&');
      }
      if(search.length == 1) {
        search = '';
      }
      return `${this.baseUrl}/${page}.html${search}`;
    },
    async sendPreview() {
      console.debug('sending preview');
      if(this.isDirty()) {
        this.$store.dispatch('ui/notify', {error: true, text: this.$t('forms.edit.preview.dirty')})
        return;
      }
      this.sending = true;
      await fetch(this.getPreviewUrl('optinEmail'));
      this.sending = false;
    },
    openPreview(page) {
      //console.debug('detect change', this.detectChange(this.fields, this.item), this.isDirty());
      if(this.isDirty()) {
        this.$store.dispatch('ui/notify', {error: true, text: this.$t('forms.edit.preview.dirty')})
        return;
      }
      window.open(this.getPreviewUrl(page), '_blank');
    },
    getPreviewUrl(type) {
      return `${this.trackerUrl}/visitors/form/${this.item.id}/preview/${type}?email=${encodeURIComponent(this.recipient)}`
    },
    openPicker() {
        this.colorPicker.selected = this.optinEmail.buttonColor;
        this.colorPicker.dialog = true;
    },
    updateColor() {
      this.colorPicker.dialog = false;
      let val = typeof(this.colorPicker.selected) === 'string' ? this.colorPicker.selected : this.colorPicker.selected.hexa
      this.optinEmail.buttonColor = val;
      //this.colorPicker.color = val;
    },
    clearColor() {
      this.optinEmail.buttonColor = null;
    }
  }
}
</script>

<style>

</style>